module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "toc-chap"
  })]), _c('td', {
    staticClass: "w75"
  }, [_c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Preface")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Intro#fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("INTRODUCTION")])])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Intro#fm-2"
    }
  }, [_vm._v("Defining a Scholar")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v(". B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOMING A")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOLAR")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 1")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("Childhood (1943–1955)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 2")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adolescence (1955–1963)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 3")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monastic Life (1963–1971)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 4")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doctoral Studies (1971–1976)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v(". B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EING A")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOLAR")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 5")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yale Divinity School (1976–1982)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 6")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indiana University (1982–1992)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 7")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emory University (1992–2001)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 8")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emory University (2001–2016)")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 9")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scholarship in Academic Retirement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/020_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HREE")]), _vm._v(". A S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOLAR")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRTUES")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 10")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intellectual Virtues")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("CHAPTER")]), _vm._v(" 11")])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moral Virtues")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("EPILOGUE")])])])]), _c('td', [_c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking Back and Forward")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-bm"
  })]), _c('td', [_c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Endnotes#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bd9c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0